// @flow
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router';
import { Box } from 'grommet';
import { withConfirmation } from 'speed-js-react';
import { withLeaflet } from 'react-leaflet';
import type { LeafletContext } from 'react-leaflet/lib/types';
import ContentRow from 'esm-web-pro/components/layout/sidePanel/ContentRow';
import RowActions from 'esm-web-pro/components/layout/sidePanel/RowActions';
import MeatballsIcon from 'esm-web-pro/components/layout/sidePanel/icons/MeatballsIcon';
import actionMessages from 'esm-web-pro/messages/actionMessages';
import cableAndFiberMessages from 'esm-web-pro/messages/cableAndFiberMessages';
import { highlightFiberCircuit } from 'esm-web-pro/containers/pages/network/highlight';
import { FiberTextContainer, CableFiberColor } from 'esm-web-pro/containers/pages/network/objects/cable/CableFiber';
import { POINT12_CONTENT_TOOLTIP_KEY } from './CableList/Point12CableList';

type Props = {
    fiber: Object,
    getFiberCableSeq: Function,
    intl: IntlContext,
    match: Object,
    history: Object,
    pointCoords: [number, number],
    onView: Function,
    getCircuit: Function,
    setClickedRowIdentity: Function,
    clickedRowIdentity: string,
    leaflet: LeafletContext,
    highlightFiber: Function,
}

const SplicedFiberRow = (props: Props) => {
    const {
        fiber, getFiberCableSeq, intl: { formatMessage }, onView, getCircuit, pointCoords,
        setClickedRowIdentity, clickedRowIdentity, highlightFiber, leaflet: { map },
    } = props;

    const visualiseFiber = (f) => {
        getCircuit().then((fiberPaths) => {
            const [fibersCallbacks, circuitPath] = highlightFiberCircuit(fiberPaths.path, f, map, highlightFiber,
                pointCoords);
            onView(`fiber-${f.id}`, fibersCallbacks, circuitPath);
        });
    };

    const actions = [{
        key: `${fiber.uuid}-more`,
        icon: <MeatballsIcon />,
        size: '20px',
        width: '3px',
        callback: (e: SyntheticMouseEvent<HTMLButtonElement>) => {
            e.stopPropagation();
            const path = props.match.url.split('/layer');
            props.history.push(`${path[0]}/layer/fiber/${fiber.identity}`);
        },
        tooltip: formatMessage(actionMessages.more),
        tooltipKey: POINT12_CONTENT_TOOLTIP_KEY,
    }];

    const cableSequence = getFiberCableSeq(fiber.container);
    const rowId = `F${fiber.id}`;

    const cableText = `${formatMessage(fiber.container.patch ? cableAndFiberMessages.patchCableLong
        : cableAndFiberMessages.cableLong)} ${cableSequence}
    (${fiber.container.fiber_count.name}, ${fiber.container.patch ? fiber.container.length
    : fiber.container.reserve || '0'} m) / `;

    const fiberText = `${formatMessage(cableAndFiberMessages.fiberLong)} ${fiber.sequence_number}`;

    // console.log('SplicedFiberRow', fiber);
    return (
        <ContentRow
            hoverIndicator="light-2"
            onClick={() => {
                setClickedRowIdentity(rowId);
                visualiseFiber(fiber);
            }}
            padLevel={2}
            key={fiber.uuid}
            rowId={rowId}
            clickedRowIdentity={clickedRowIdentity}
            actions={(
                <RowActions
                    iconPadding="3px"
                    gapBetweenActions="medium"
                    actions={actions}
                />
            )}
        >
            <Box
                width="350px"
                onClick={() => {}}
            >
                <FiberTextContainer>
                    {cableText}
                    {(fiber.attributes?.color) && (
                        <CableFiberColor
                            color={fiber.attributes.color}
                            stripeCount={fiber.attributes.stripe_count}
                            tubeNumber={fiber.attributes.tube_number}
                        />
                    )}
                    {fiberText}
                </FiberTextContainer>
            </Box>
        </ContentRow>
    );
};

export default withLeaflet(withRouter(injectIntl((withConfirmation(SplicedFiberRow)))));
